import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/apps/legacy-frontend/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager", webpackExports: ["DynamicNavigationProvider"] */ "/app/apps/legacy-frontend/src/components/DynamicNavigationProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material-nextjs/esm/v13-appRouter/appRouterV13.js");
